import React from 'react';

const SplashHero = () => {
	return (
		<div className="fi-splash-hero-image">
			<img alt="Splash hero" src={window.findaConnector.splashHero} />
		</div>
	);
};

export default SplashHero;
